import * as events from "@/store/helpdesk/siteinfo/event-types";

export const mutations = {
  [events.HELPDESK_SET_SITE_INFO](state, site_info) {
    state.helpdesk_site_info = site_info;
  },
};
